module.exports = __webpack_public_path__ + "images/emoji/monorail.58b5abb93768d0e3cd48.png";